import { render, staticRenderFns } from "./SaveCloud.vue?vue&type=template&id=e295bcf8&lang=pug&"
import script from "./SaveCloud.vue?vue&type=script&lang=ts&"
export * from "./SaveCloud.vue?vue&type=script&lang=ts&"
import style0 from "./SaveCloud.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\as3-portals\\AS3.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e295bcf8')) {
      api.createRecord('e295bcf8', component.options)
    } else {
      api.reload('e295bcf8', component.options)
    }
    module.hot.accept("./SaveCloud.vue?vue&type=template&id=e295bcf8&lang=pug&", function () {
      api.rerender('e295bcf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/icons/SaveCloud.vue"
export default component.exports